import { determinTransferStatus } from "../../../../lib/misc";
import TransferToClinic from "./TransferToClinic";

import classes from './TransferClinicWrapper.module.css'
import TransferClinicCancel from "./TransferClinicCancel";
import TransferClinicComplete from "./TransferClinicComplete";
import BodySimpleModalV3 from "../../../common/modal/BodySimpleModalV3";
import { isTransferAlowed } from "../../../../lib/script";
import { useSelector } from "react-redux";

export default function TransferClinicWrapper({children, item}) {
    const editPermissions = useSelector(state => state.permissions.editPermissions)
    const canCompleteTransfer = !!editPermissions?.practice_complete_transfer
    const canAddTransfer = !!editPermissions?.practice_add_transfer

    if ( !isTransferAlowed(item?.practice_id) ) {
        return <div className={`${classes.td_replacement}`}>{children}</div>
    }

    if (determinTransferStatus(item.case_practice_transfers) == 'pending') {
        return <div className={`${classes.td_replacement} ${classes.pending}`}>
            <BodySimpleModalV3 message={'Clinic transfer in progress.'} >
                <div className="flex-container flex-container-space-betwen">                
                    {children}
                    <div className="flex-container">
                        {canCompleteTransfer && <TransferClinicComplete practiceData={item} status={'Pending'}/>}
                        <TransferClinicCancel practiceData={item} status={'Pending'}/>
                    </div>
                </div> 
            </BodySimpleModalV3>
        </div>
    }

    if (determinTransferStatus(item.case_practice_transfers) == 'review') {
        return <div className={`${classes.td_replacement} ${classes.review}`}>
            <BodySimpleModalV3 message={'Clinic transfer in progress.'} >
                <div className="flex-container flex-container-space-betwen">                
                    {children}
                    <div className="flex-container">
                        {canCompleteTransfer && <TransferClinicComplete practiceData={item} status={'Review'}/>}
                        <TransferClinicCancel practiceData={item} status={'Review'}/>
                    </div>
                </div> 
            </BodySimpleModalV3>
        </div>
    }

    return <div className={`${classes.td_replacement}`}>
        <div className="flex-container flex-container-space-betwen">
            {children}
            {canAddTransfer && <TransferToClinic practiceData={item}/>}
        </div>
    </div>
}
